import { extractQueryStringFromCurrentUrl, getApiUrl, getBaseUrl, removeLeadingSlash } from './common';
import HttpClient from './http-client';

export interface LanguageOption {
    optionElement: HTMLElement;
    languageId: number;
}


export default class LanguageSelector {
    baseElement: Element;
    options: LanguageOption[];
    pageId: number;
    productId: string;

    init(baseElement: Element): void {
        this.baseElement = baseElement;
        this.options = this.createLanguageOptions(this.baseElement.querySelectorAll('p[data-value]'));
        this.pageId = Number(this.baseElement.getAttribute('data-page-id'));
        this.productId = this.getProductId();
        this.registerOptionListeners();
    }

    private getProductId() {
        return this.baseElement.getAttribute('data-product-id');
    }

    private registerOptionListeners(): void {
        this.options.forEach((option: LanguageOption) => {
            option.optionElement.addEventListener('click', async (e: Event) => {
                e.preventDefault();
                await this.switchLanguage(option.languageId)
            })
        });
    }

    private createLanguageOptions(elements: NodeList): LanguageOption[] {

        return [...elements].map((e: Element) => this.parseLanguageOption(<HTMLElement>e));
    }

    private parseLanguageOption(element: HTMLElement): LanguageOption {
        return {
            optionElement: element,
            languageId: Number.parseInt(element.getAttribute('data-value'))
        }
    }

    private  async switchLanguage(languageId: number): Promise<void> {
        await this.switchToLanguage(Number(languageId));
    }

    private async switchToLanguage(languageId: number): Promise<void> {
        const apiUrl = this.getApiUrl();

        let url = `${apiUrl}?pageId=${this.pageId}&languageId=${languageId}`;
        if (this.productId) {
            url += `&productId=${this.productId}`;
        }

        const response = await new HttpClient().fetch(url);
        if(response && response.ok) {
            const localizedUrl =  await response.text();
            this.redirectToPage(localizedUrl);
        } 
        else {
            console.error('Error occured while attempting change language.')
        }
    }

    private redirectToPage(pageUrl: string): void {
        pageUrl = removeLeadingSlash(pageUrl);
        const baseUrl = getBaseUrl();
        const queryParameters = extractQueryStringFromCurrentUrl();

        window.location.href = `${baseUrl}${pageUrl}${queryParameters ? '?' : ''}${queryParameters}`;
    }

    private getApiUrl(): string {
        return `${getApiUrl()}/languages`;
    }
}
